import { post, get, put, del } from "@/utils/request";

// 个人中心-输入密码，验证登录
export function personalCenterCheck(data) {
  return post("/api/dots-platform/personalCenter/check", data);
}

// 个人中心-修改密码
export function personalCenterChangePassword(data) {
  return post("/api/dots-platform/personalCenter/changePassword", data);
}

// 个人中心-修改手机号
export function personalCenterChangeMobile(data) {
  return post("/api/dots-platform/personalCenter/changeMobile", data);
}

// 个人中心-修改邮箱
export function personalCenterChangeEmail(data) {
  return post("/api/dots-platform/personalCenter/changeEmail", data);
}

// 个人中心-注销申请
export function personalCenterUserCancel(uid) {
  return get(`/api/dots-platform/user/doCancel?uid=${uid}`);
}

//注销授权书
export function readCancelNotice() {
  return get(`/api/dots-platform/user/readCancelNotice`);
}

// 首页跳转TTS打标
export function setLoginTagApi(accountId, loginForm) {
  return get(
    `/api/dots-platform/home/setLoginTag?accountId=${accountId}&loginForm=${loginForm}`,
  );
}

// 更新弹窗是否展示
// action 当前url
// userType 1代表终端人 2代表后台管理员 创建采购写死2
export function tipsCue(data) {
  return get(`/api/dots-platform/tips/cue`, data);
}

// 更新弹窗关闭按钮
export function tipsCloseCue(data) {
  return get(`/api/dots-platform/tips/closeCue`, data);
}

// 文件上传 通用方法
export function uploadFile(data) {
  return post(`/api/exam/storage/upload`, data);
}

// 登录后获取 - 涉税信息更新提示
export function loginTips() {
  return get(`/api/auth-sign-java/tabClient/loginTips`);
}

// 登录后获取 - 经查实更新提示
export function loginTipsJc() {
  return get(`/api/auth-sign-java/tabClient?tab=jc`);
}

// 登录后获取 - 更新
export function taxUpdate(data) {
  return post(`/api/auth-sign-java/tabClient/taxUpdate`, data);
}
